import router from "@/router";

export const goPage = (page, params = {}) => {

  let str = '?'

  let keys = Object.keys(params)
  if (keys.length) {
    keys.forEach(k => {
      str += k + '=' + params[k] + '&'
    })
  }

  if (str === '?') {
    str = ''
  }

  if (str.endsWith('&')) {
    str = str.substring(0, str.length - 1)
  }

  // params.randomStr = Math.random().toString().substring(2,8)

  if (page === '') return router.push('/')
  if (page === 'lvDeviceInfo') return router.push({path: '/lv/lvDeviceInfo', query: params})
  if (page === 'deviceEmulator') return router.push({path: '/device/deviceEmulator', query: params})
}

export default {
  goPage
}
